/******************************************************************
* @NAME y.xiang
* @CREATEDATE 2022/3/21
* @DESC <
 * 录入指纹逻辑
 *1、用户添加指纹时，需要选择当前管理员使用的Fingerprint Reader
 *2、选择好Fingerprint Reader后，点击录入按钮，开始录入指纹
 *3、选择一个指纹进行录入，录入成功后可删除后重新录入该指纹，比如指纹1录入成功后感到不满意，可直接删除重新选择录入指纹1
 *4、录入过程中，可以删除已录入的指纹，也可以点击close、Cancel Entering等按钮中断录入过程
 *5、一次只能录入一个指纹，录入一个后，需要再次点击录入按钮才能继续录入指纹
 *6、在非录入指纹的状态下，可以删除已录入的指纹
 *7、保存指纹后，系统会记住管理员最近一次选中的Fingerprint Reader，下次点击录入按钮会直接开始录入，而不需要再次选择Reader并点击录入指纹
 *8、指纹与PIN、Temp Access一样，一旦开启功能后，对应的管理、报表模块都要显示对应信息
 *9、失败返回状态通过设备返回，预留失败图标
 *
 *
 * >
* ****************************************************************/
export default {
  name: "utmFingerprint",
  props:{
    /*用户已经录入的指纹*/
    fingerprint:{
      type:Array,
      default(){
        return [];
      }
    }
  },
  data(){
    return{
      fingerprintData:[],
      enteringFingerModal:false,
      readerIds:[],
      readerList:[],
      isEntering:false,//是否正在录入
      enterResult:null,//录入结果 0——表示正在录入   1——表示录入成功   2——表示录入失败
      enterFingerprintIndex:null,//正在录入指纹的名字（或者只下标）
      messageDesc:'Failed to input fingerprint. Please input fingerprint again',//获取指纹失败的原因描述
      isConent:false,
      isConenting:true,
      activeDot: 0,
      timer:null,
      boderColor:['rgba(114,200,242,1)','rgba(5,159,232,.3)','rgba(5,159,232,.1)'],
      index: null,
      intervalId:null,
      sTimer:null,
      isshowGif:true
    }
  },
  mounted(){
    this.getStimer();
  },
  beforeDestroy(){
    clearTimeout(this.timer);
    clearTimeout(this.sTimer);
  },
  methods:{
    getStimer(){
      if(!this.isConent){
        let that = this;
        this.sTimer = setTimeout(() => {
          that.activeDot = (that.activeDot + 1) % 6;
          that.getStimer();
        }, 500);
      }
    },
    getFingerStatus(){
      let that = this;
      this.$ajax.get('FingerPrint/Initialize',{baseURL: window.g.Fingerprint_ROOT,headers:{noLoading:true}}).then(res=>{
         if(res.data.success){
          this.isConent = true;
          clearTimeout(this.sTimer);
         }else{
          this.timer = setTimeout(function () {
            that.getFingerStatus();
          },3000);

         }
      })
    },
    //打开设置指纹模态框
    openFingerprintModal:function(){
      this.enteringFingerModal = true;
      this.getFingerStatus()
      //获取指纹机
      this.isEntering = false;
      this.enterResult = null;
      this.enterFingerprintIndex = null;
      //可以录入指纹的个数
      this.fingerprintData = [];
      if(this.ApiService.fingerprintInfo && this.ApiService.fingerprintInfo.maxPerPersonFingerprintAmount > 0){
        for(let i = 0; i < this.ApiService.fingerprintInfo.maxPerPersonFingerprintAmount; i++){
          //判断当前的指纹是否已经录入
          let obj = this.fingerprint.find(item => {
            return item.name/1 === i;
          });
          if(obj && obj.data){
            this.fingerprintData.push(obj);
          }else{
            this.fingerprintData.push({'name':'' + i, fingerprintId:null,data:''});
          }
        }
      }
    },
    //录入指纹
    enterFingerprint:function(){
      this.isEntering = true;
      this.enterResult = 0;
      let that = this;
      that.messageDesc = 'Failed to input fingerprint. Please input fingerprint again';
      if(this.readerIds && this.readerIds.length > 2){
        this.$ajax.post('Fingerprint/GetFingerprint?id=' + this.readerIds[2],{},{headers: {noLoading: true}}).then(res =>{
          if(res.data.success && res.data.data && that.isEntering){
            //录入成功
            that.enterResult = 1;
            that.fingerprintData[that.enterFingerprintIndex].fingerprintId = res.data.data;
          }else if(that.isEntering){
            //录入失败
            that.enterResult = 2;
            that.fingerprintData[that.enterFingerprintIndex].fingerprintId = '';
            that.messageDesc = res.data.message;
          }
        }).catch(() => {
          //录入失败
          if(that.isEntering){
            that.enterResult = 2;
            that.fingerprintData[that.enterFingerprintIndex].fingerprintId = '';
          }
        });
      }
    },
    //取消正在录入的指纹
    cancelFingerprint:function(){
      this.isEntering = false;
      this.enterResult = null;
    },
    //切换录入的指纹机
    changeFingerprintReader:function(){

    },
    reFingerprint(){
      this.isshowGif = true
      this.enterResult = null;
      this.getFingerprint();
    },
    getFingerprint(data){
      let that = this;
      if(!this.enterResult){
        this.intervalId = setInterval(() => {
          that.index = (this.index + 1) % 3;
        }, 500);
      }
      if( that.isEntering ){
        return false;
      }
      if(data){
        that.enterFingerprintIndex = data.name/1;
        that.enterResult = null;
      }
      that.isEntering = true;
      this.$ajax.get('FingerPrint/GetTemplate?index=0&timeout='+ window.g.FingerTime,{baseURL: window.g.Fingerprint_ROOT,headers:{noLoading:true}}).then(res=>{
        that.index = null;
        clearInterval(this.intervalId);
       
        if(res.data.success && res.data.data && that.isEntering && res.data.data.template != ''){
          //录入成功
          that.isshowGif = true;
          that.enterResult = 1;

          setTimeout(function () {
            that.isshowGif = false;
          },800);
          that.fingerprintData[that.enterFingerprintIndex].fingerprintId = null;
          that.fingerprintData[that.enterFingerprintIndex].data = res.data.data.template;
          that.isEntering = false;
        }else{
          //录入失败
          if(that.isEntering){
            that.isshowGif = true;
            that.enterResult = 2;
            setTimeout(function () {
              that.isshowGif = false;
            },800);
           
            that.fingerprintData[that.enterFingerprintIndex].fingerprintId = null;
            that.fingerprintData[that.enterFingerprintIndex].data = '';
            that.messageDesc = res.data.message;
            that.isEntering = false;
          }
        }
      }).catch(() => {
        //录入失败
        if(that.isEntering){
          that.index = null;
          clearInterval(this.intervalId);
          that.enterResult = 2;
          that.fingerprintData[that.enterFingerprintIndex].fingerprintId = null;
          that.fingerprintData[that.enterFingerprintIndex].data = '';
          that.isEntering = false;
        }
      });
      
    },
    //切换录入的指纹
    changeEnterFingerprintIndex:function(data){
      this.enterResult = null;
      this.isshowGif = true
      if( !data.data){
        this.getFingerprint(data);

      }
    },
    /**删除非录入状态即没有打开录入弹层的时候的指纹 (6、在非录入指纹的状态下，可以删除已录入的指纹)**/
    deleteEnteredFingerprint:function(index){
      this.fingerprint.splice(index,1);
    },
    /**删除弹层上的指纹(3、选择一个指纹进行录入，录入成功后可删除后重新录入该指纹，比如指纹1录入成功后感到不满意，可直接删除重新选择录入指纹1)*/
    deleteFingerprint:function(index){
      this.fingerprintData[index].data = '';
      this.getFingerprint();
    },
    /**关闭设置指纹模态框(7、保存指纹后，系统会记住管理员最近一次选中的Fingerprint Reader，下次点击录入按钮会直接开始录入，而不需要再次选择Reader并点击录入指纹)*/
    closeFingerprintModal:function(){
      clearTimeout(this.timer);
      this.enteringFingerModal = false;
      let data = this.fingerprintData.filter((item) => {
        if(item.data){
          return item;
        }
      });
      this.$emit('changeFinger',  data);
    },
    //获取指纹设备（即指纹机）
    getFingerprintDevice:function(){
      let that = this;
      that.readerList = [];
      that.shareApi.getAccessZoneOptions({types:[1]}).done(result => {
        result.forEach(item => {
          if(item.type !== 1){
            return false;
          }
          //是否存在指纹机
          let fingerDevice = item.devices.filter(device => {
            return device.deviceType === 2006;
          });
          if(fingerDevice.length === 0){
            return false;
          }
          item.sites = item.sites.map(site => {
            that.$set(site,'children',fingerDevice.filter(device => {
              return site.id === device.accessSiteId;
            }).map(device => {
              device.label = device.deviceName;
              device.value = device.deviceId;
              return device;
            }));
            site.label = site.name;
            site.value = site.id;
            return site
          }).filter((site) => {
            return site.children && site.children.length > 0;
          });
          that.readerList.push({value:item.id, label:item.name,children:item.sites});
        });
      });
    },

  },
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/utmFingerprint.js